import {
	isMessageSetField,
	isMessageSetFrameId,
	isMessageSetMobile,
	isMessageUpdateContent,
	isMessageUpdateRects,
} from './scripts/components/product-preview/typeguards';
import { MessageUpdateRect } from './scripts/components/product-preview/types';

let frameId: string | null = null;

const areaElements = Array.from(
	document.querySelectorAll<HTMLElement>('[data-area]')
).map((el) => {
	const id = el.getAttribute('data-area')!;

	const updateRect = () => {
		const rect = el.getBoundingClientRect();

		if (rect.width === 0 || rect.height === 0 || frameId === null) return;

		const message: MessageUpdateRect = {
			type: 'update-rect',
			id,
			rect,
			frameId,
		};
		parent.postMessage(message);
	};

	updateRect();

	const observer = new ResizeObserver((entries) => {
		for (const entry of entries) {
			if (entry.contentRect) {
				updateRect();
			}
		}
	});

	observer.observe(el);

	return { updateRect };
});

const fieldElements = Array.from(
	document.querySelectorAll<HTMLElement>('[data-field]')
).map((el) => {
	const id = el.getAttribute('data-field')!;

	return { id, el };
});

const updateRects = () => {
	areaElements.forEach(({ updateRect }) => updateRect());
};

/**
 * Listen for messages to update content
 */
window.addEventListener('message', (event) => {
	const message = event.data;

	if (isMessageSetFrameId(message)) {
		frameId = message.frameId;
	}

	if (isMessageUpdateContent(message)) {
		let shouldUpdateRects = false;
		fieldElements.forEach(({ id, el }) => {
			const value = message.fieldValues[id];

			if (value !== undefined && value !== '') {
				el.classList.add('has-value');
				if (el instanceof HTMLImageElement) {
					el.src = value;
				} else {
					el.innerText = value;
					shouldUpdateRects = true;
				}
			}
		});

		if (shouldUpdateRects) {
			window.setTimeout(updateRects, 1);
		}
	}

	if (isMessageSetMobile(message)) {
		document.documentElement.classList.toggle('is-mobile', message.mobile);
		updateRects();
	}

	if (isMessageSetField(message)) {
		document.documentElement.classList.toggle('is-editable', message.editable);
		updateRects();
	}

	if (isMessageUpdateRects(message)) {
		updateRects();
	}
});

window.addEventListener('load', updateRects);
window.addEventListener('DOMContentLoaded', updateRects);
